// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.\\------packages-foundation-layout-src-components-global-error-index-module__wrapper-mJK747 {
  width: 100%;
  height: 100%;
}

.\\------packages-foundation-layout-src-components-global-error-index-module__content-FxpIxN {
  flex-direction: column;
  align-items: center;
  margin: auto;
  padding-top: 35.39vh;
  display: flex;
}

.\\------packages-foundation-layout-src-components-global-error-index-module__title-h1Vtcc {
  margin-top: 24px !important;
  margin-bottom: 4px !important;
  font-size: 16px !important;
  font-weight: 600 !important;
  line-height: 22px !important;
}

.\\------packages-foundation-layout-src-components-global-error-index-module__paragraph-isj9qQ {
  color: rgba(29, 28, 35, .6);
  margin-bottom: 8px;
  font-size: 12px;
  line-height: 16px;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `------packages-foundation-layout-src-components-global-error-index-module__wrapper-mJK747`,
	"content": `------packages-foundation-layout-src-components-global-error-index-module__content-FxpIxN`,
	"title": `------packages-foundation-layout-src-components-global-error-index-module__title-h1Vtcc`,
	"paragraph": `------packages-foundation-layout-src-components-global-error-index-module__paragraph-isj9qQ`
};
export default ___CSS_LOADER_EXPORT___;
